import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    newObject: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    toolsWrapper: {
        minWidth: '500px',
    },
}));
